import React, { useState, useEffect, useRef } from 'react';

const CourtScoreboard = ({ courtNumber, match }) => {
    if (!match) {
        return (
            <div style={{
                textAlign: 'center',
                padding: '40px',
                borderRadius: '12px',
                border: '2px solid #ff0000ff',
                background: '#fff'
            }}>
                <div style={{ fontSize: '60px', marginBottom: '15px' }}>🏸</div>
                <h2 style={{ color: '#333', marginBottom: '8px', fontSize: '24px' }}>Court {courtNumber}</h2>
                <p style={{ color: '#666', fontSize: '16px' }}>No Live Match</p>
            </div>
        );
    }

    const side1 = match.isDoubles ? match.team1 : match.player1;
    const side2 = match.isDoubles ? match.team2 : match.player2;
    const side1Name = match.isDoubles ? side1.players.join(' & ') : side1.name;
    const side2Name = match.isDoubles ? side2.players.join(' & ') : side2.name;

    const getSetWinner = (setIndex) => {
        const p1Score = match.isDoubles ? match.team1.scores[setIndex] : match.player1.scores[setIndex];
        const p2Score = match.isDoubles ? match.team2.scores[setIndex] : match.player2.scores[setIndex];

        if (p1Score === undefined || p2Score === undefined) return null;
        if (p1Score >= 21 && p1Score - p2Score >= 2) return 1;
        if (p2Score >= 21 && p2Score - p1Score >= 2) return 2;
        if (p1Score >= 30 || p2Score >= 30) return p1Score > p2Score ? 1 : 2;
        return null;
    };

    const getSetsWon = (side) => {
        let won = 0;
        for (let i = 0; i < 3; i++) {
            if (getSetWinner(i) === side) won++;
        }
        return won;
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{
                borderRadius: '6px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                background: '#fff'
            }}>
                {/* Player 1 Row */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '40px 1fr repeat(3, 45px)',
                    alignItems: 'stretch',
                    borderBottom: '2px solid #d0d0d0'
                }}>
                    {/* Icon */}
                    <div style={{
                        background: '#e8e8e895',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '8px'
                    }}>
                        <div style={{ fontSize: '20px' }}>🏸</div>
                    </div>

                    {/* Name and State */}
                    <div style={{
                        padding: '10px 12px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        background: '#ffffff',
                        gap: '2px',
                        borderBottom: '1px solid #e0e0e0'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{
                                fontSize: match.isDoubles ? '14px' : '16px',
                                fontWeight: 'bold',
                                color: '#1a1a1a',
                                textTransform: 'uppercase',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {side1Name}
                            </span>
                            {side1.serving && (
                                <div style={{
                                    background: '#ffd700',
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    flexShrink: 0
                                }} />
                            )}
                        </div>
                        {side1.state && (
                            <div style={{
                                fontSize: '11px',
                                color: '#666',
                                fontWeight: '500'
                            }}>
                                {side1.state}
                            </div>
                        )}
                    </div>

                    {/* Set Scores */}
                    {[0, 1, 2].map((setIndex) => {
                        const score = side1.scores[setIndex];
                        const isCurrentSet = match.currentSet === setIndex + 1;
                        const winner = getSetWinner(setIndex);

                        return (
                            <div
                                key={setIndex}
                                style={{
                                    background: isCurrentSet ? '#ffd700' : winner === 1 ? '#4caf50' : '#e8e8e8',
                                    color: isCurrentSet || winner === 1 ? (isCurrentSet ? '#000' : '#fff') : '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    padding: '10px 0',
                                    borderBottom: '1px solid #d0d0d0'
                                }}
                            >
                                {score > 0 ? score : '-'}
                            </div>
                        );
                    })}
                </div>

                {/* Player 2 Row */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '40px 1fr repeat(3, 45px)',
                    alignItems: 'stretch'
                }}>
                    {/* Icon */}
                    <div style={{
                        background: '#e8e8e895',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '8px'
                    }}>
                        <div style={{ fontSize: '20px' }}>🏸</div>
                    </div>

                    {/* Name and State */}
                    <div style={{
                        padding: '10px 12px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        background: '#ffffff',
                        gap: '2px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{
                                fontSize: match.isDoubles ? '14px' : '16px',
                                fontWeight: 'bold',
                                color: '#1a1a1a',
                                textTransform: 'uppercase',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {side2Name}
                            </span>
                            {side2.serving && (
                                <div style={{
                                    background: '#ffd700',
                                    width: '6px',
                                    height: '6px',
                                    borderRadius: '50%',
                                    flexShrink: 0
                                }} />
                            )}
                        </div>
                        {side2.state && (
                            <div style={{
                                fontSize: '11px',
                                color: '#666',
                                fontWeight: '500'
                            }}>
                                {side2.state}
                            </div>
                        )}
                    </div>

                    {/* Set Scores */}
                    {[0, 1, 2].map((setIndex) => {
                        const score = side2.scores[setIndex];
                        const isCurrentSet = match.currentSet === setIndex + 1;
                        const winner = getSetWinner(setIndex);

                        return (
                            <div
                                key={setIndex}
                                style={{
                                    background: isCurrentSet ? '#ffd700' : winner === 2 ? '#4caf50' : '#e8e8e8',
                                    color: isCurrentSet || winner === 2 ? (isCurrentSet ? '#000' : '#fff') : '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    padding: '10px 0'
                                }}
                            >
                                {score > 0 ? score : '-'}
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Match Info */}
            <div style={{
                marginTop: '12px',
                padding: '8px 12px',
                background: '#f5f5f5',
                borderRadius: '6px',
                color: '#666',
                fontSize: '12px',
                border: '1px solid #e0e0e0'
            }}>
                <div style={{ marginBottom: '4px' }}>
                    <strong style={{ color: '#1a1a1a' }}>Court {courtNumber}</strong> • {match.categoryName}
                </div>
                <div>
                    {match.roundName} • Set {match.currentSet} • {getSetsWon(1)}-{getSetsWon(2)}
                </div>
            </div>
        </div>
    );
};

const DualCourtPage = () => {
    const [matches, setMatches] = useState({ court1: null, court2: null });
    const [loading, setLoading] = useState(true);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [error, setError] = useState(null);
    const pollingIntervalRef = useRef(null);
    const sideLabelsCache = useRef({});

    const API_BASE_URL = 'https://api.asterickx.com/api/MatchScoring';
    const API_ALL_LIVE = `${API_BASE_URL}/GetAllLiveScore`;
    const TOURNAMENT_ID = '7f479cd9-9169-488b-8f06-dc57b6ab64b1';
    const API_SIDE_LABELS = `${API_BASE_URL}/tournament/${TOURNAMENT_ID}/side-labels`;

    const parseSideDisplay = (displayString) => {
        if (!displayString) return { players: [], state: '' };
        
        // Extract state from parentheses at the end
        const stateMatch = displayString.match(/\(([^)]+)\)\s*$/);
        const state = stateMatch ? stateMatch[1] : '';
        
        // Remove state part and extract player names
        const namesOnly = displayString.replace(/\s*\([^)]+\)\s*$/, '').trim();
        
        // Split by & or / to get individual players
        let players = [];
        if (namesOnly.includes(' & ')) {
            players = namesOnly.split(' & ').map(p => p.trim());
        } else if (namesOnly.includes(' / ')) {
            players = namesOnly.split(' / ').map(p => p.trim());
        } else {
            players = [namesOnly];
        }
        
        return { players, state };
    };

    const fetchTournamentSideLabels = async () => {
        try {
            const response = await fetch(API_SIDE_LABELS);
            
            if (!response.ok) {
                return {};
            }
            
            const data = await response.json();
            
            // Convert array to map by matchId for easy lookup
            const labelsMap = {};
            if (Array.isArray(data)) {
                data.forEach(item => {
                    if (item.matchId) {
                        labelsMap[item.matchId] = item;
                    }
                });
            }
            
            return labelsMap;
        } catch (error) {
            console.error('Error fetching tournament side labels:', error);
            return {};
        }
    };

    const fetchMatchDetails = async (matchId) => {
        try {
            const response = await fetch(`${API_BASE_URL}/${matchId}`);
            if (!response.ok) return null;
            return await response.json();
        } catch (error) {
            console.error(`Error fetching match ${matchId}:`, error);
            return null;
        }
    };

    const getFirstName = (fullName) => {
        if (!fullName) return '';
        return fullName.trim().split(' ')[0];
    };

    const parsePlayerNames = (nameString) => {
        if (!nameString) return [];
        
        let players = [];
        
        if (nameString.includes(' & ')) {
            players = nameString.split(' & ').map(p => getFirstName(p));
        } else if (nameString.includes(' / ')) {
            players = nameString.split(' / ').map(p => getFirstName(p));
        } else if (nameString.includes('/')) {
            players = nameString.split('/').map(p => getFirstName(p));
        } else {
            players = [getFirstName(nameString)];
        }
        
        return players.filter(p => p.length > 0);
    };

    const convertApiDataToMatch = async (apiData, liveData, sideLabelsData = null) => {
        const matchData = apiData || liveData;
        const matchId = matchData.matchId;

        const sets = matchData.sets || [];

        // Determine current set number
        let currentSetNumber = 1;
        if (liveData?.currentSetNumber) {
            currentSetNumber = liveData.currentSetNumber;
        } else if (matchData?.currentSetNumber) {
            currentSetNumber = matchData.currentSetNumber;
        } else {
            // Find the last set with activity
            for (let i = sets.length - 1; i >= 0; i--) {
                const set = sets[i];
                const s1 = set.side1Score || 0;
                const s2 = set.side2Score || 0;
                
                // Check if this set is complete (someone won)
                const isComplete = (s1 >= 21 && s1 - s2 >= 2) || 
                                   (s2 >= 21 && s2 - s1 >= 2) ||
                                   (s1 >= 30 || s2 >= 30);
                
                if (!isComplete && (s1 > 0 || s2 > 0)) {
                    // This set has activity but isn't complete - it's current
                    currentSetNumber = i + 1;
                    break;
                } else if (isComplete) {
                    // This set is complete, next set is current
                    currentSetNumber = i + 2;
                    break;
                }
            }
            // Ensure we don't exceed set 3
            if (currentSetNumber > 3) currentSetNumber = 3;
        }

        let p1A = "", p1B = "", p2A = "", p2B = "";
        let side1State = "", side2State = "";
        
        // Use side labels data if available - it provides individual player names and IDs
        if (sideLabelsData) {
            console.log('Side labels for match:', matchId, sideLabelsData);
            
            // For side 1 - always parse if side1Display exists
            if (sideLabelsData.side1Display) {
                const side1Parts = parseSideDisplay(sideLabelsData.side1Display);
                console.log('Side 1 parsed:', side1Parts);
                p1A = side1Parts.players[0] || "";
                p1B = side1Parts.players[1] || "";
                side1State = side1Parts.state || "";
            }
            
            // For side 2 - always parse if side2Display exists
            if (sideLabelsData.side2Display) {
                const side2Parts = parseSideDisplay(sideLabelsData.side2Display);
                console.log('Side 2 parsed:', side2Parts);
                p2A = side2Parts.players[0] || "";
                p2B = side2Parts.players[1] || "";
                side2State = side2Parts.state || "";
            }
        }
        
        // Determine if this is a doubles match
        const isDoublesCategory = matchData.categoryName?.toLowerCase().includes('doubles');
        const hasDoublesPlayers = (p1B && p1B.trim() !== "") || (p2B && p2B.trim() !== "") ||
                                   (sideLabelsData && (sideLabelsData.player1BId || sideLabelsData.player2BId));
        
        const side1Name = matchData.side1Label || 'Player 1';
        const side2Name = matchData.side2Label || 'Player 2';

        let side1Players = [];
        let side2Players = [];

        // For doubles matches, prioritize side labels data
        if (isDoublesCategory || hasDoublesPlayers) {
            // Add players from side labels
            if (p1A && p1A.trim() !== "") {
                side1Players.push(getFirstName(p1A));
            }
            if (p1B && p1B.trim() !== "") {
                side1Players.push(getFirstName(p1B));
            }
            if (p2A && p2A.trim() !== "") {
                side2Players.push(getFirstName(p2A));
            }
            if (p2B && p2B.trim() !== "") {
                side2Players.push(getFirstName(p2B));
            }
            
            // If still no players from side labels, parse from match data
            if (side1Players.length === 0) {
                side1Players = parsePlayerNames(side1Name);
            }
            if (side2Players.length === 0) {
                side2Players = parsePlayerNames(side2Name);
            }
        } else {
            // Singles match
            if (p1A && p1A.trim() !== "") {
                side1Players.push(getFirstName(p1A));
            } else {
                side1Players = parsePlayerNames(side1Name);
            }
            
            if (p2A && p2A.trim() !== "") {
                side2Players.push(getFirstName(p2A));
            } else {
                side2Players = parsePlayerNames(side2Name);
            }
        }

        console.log('Final players - Side1:', side1Players, 'Side2:', side2Players);

        const side1Scores = [0, 0, 0];
        const side2Scores = [0, 0, 0];

        sets.forEach((set, index) => {
            if (index < 3) {
                side1Scores[index] = set.side1Score || 0;
                side2Scores[index] = set.side2Score || 0;
            }
        });

        const isDoubles = isDoublesCategory || hasDoublesPlayers || side1Players.length > 1 || side2Players.length > 1;

        if (isDoubles) {
            return {
                id: matchData.matchId || liveData.matchId,
                categoryName: matchData.categoryName,
                roundName: matchData.roundName,
                team1: {
                    players: side1Players,
                    state: side1State,
                    scores: side1Scores,
                    serving: matchData.currentServerSide === 1
                },
                team2: {
                    players: side2Players,
                    state: side2State,
                    scores: side2Scores,
                    serving: matchData.currentServerSide === 2
                },
                currentSet: currentSetNumber,
                isDoubles: true
            };
        } else {
            return {
                id: matchData.matchId || liveData.matchId,
                categoryName: matchData.categoryName,
                roundName: matchData.roundName,
                player1: {
                    name: side1Players[0] || side1Name,
                    state: side1State,
                    scores: side1Scores,
                    serving: matchData.currentServerSide === 1
                },
                player2: {
                    name: side2Players[0] || side2Name,
                    state: side2State,
                    scores: side2Scores,
                    serving: matchData.currentServerSide === 2
                },
                currentSet: currentSetNumber,
                isDoubles: false
            };
        }
    };

    const fetchAllMatches = async (silent = false) => {
        try {
            if (!silent) setLoading(true);
            setError(null);
            
            // Fetch tournament side labels once
            const sideLabelsMap = await fetchTournamentSideLabels();
            sideLabelsCache.current = sideLabelsMap;
            
            const response = await fetch(API_ALL_LIVE);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const allMatchesData = await response.json();

            if (!Array.isArray(allMatchesData) || allMatchesData.length === 0) {
                setMatches({ court1: null, court2: null });
                if (!silent) setLoading(false);
                setLastUpdate(new Date().toLocaleTimeString());
                return;
            }

            const court1Match = allMatchesData.find(
                m => m.matchStatus === "In Progress" && m.courtNumber === "1"
            );
            const court2Match = allMatchesData.find(
                m => m.matchStatus === "In Progress" && m.courtNumber === "2"
            );

            const processedMatches = { court1: null, court2: null };

            if (court1Match) {
                const details = await fetchMatchDetails(court1Match.matchId);
                const sideLabels = sideLabelsMap[court1Match.matchId] || null;
                processedMatches.court1 = await convertApiDataToMatch(details, court1Match, sideLabels);
            }

            if (court2Match) {
                const details = await fetchMatchDetails(court2Match.matchId);
                const sideLabels = sideLabelsMap[court2Match.matchId] || null;
                processedMatches.court2 = await convertApiDataToMatch(details, court2Match, sideLabels);
            }

            setMatches(processedMatches);
            setLastUpdate(new Date().toLocaleTimeString());
            if (!silent) setLoading(false);
        } catch (error) {
            console.error('Error fetching matches:', error);
            setError(error.message);
            if (!silent) setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllMatches();
        pollingIntervalRef.current = setInterval(() => {
            fetchAllMatches(true);
        }, 5000);

        return () => {
            if (pollingIntervalRef.current) {
                clearInterval(pollingIntervalRef.current);
            }
        };
    }, []);

    if (error) {
        return (
            <div style={{ padding: '40px', textAlign: 'center', color: '#c33' }}>
                <strong>Error:</strong> {error}
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: 'transparent',
            padding: '30px',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                gap: '30px',
                maxWidth: '1400px',
                margin: '0 auto'
            }}>
                <CourtScoreboard courtNumber={1} match={matches.court1} />
                <CourtScoreboard courtNumber={2} match={matches.court2} />
            </div>

            {lastUpdate && (
                <div style={{
                    textAlign: 'center',
                    marginTop: '20px',
                    color: '#666',
                    fontSize: '14px'
                }}>
                    Last updated: {lastUpdate}
                </div>
            )}
        </div>
    );
};

export default DualCourtPage;